import r from "./index245.js";
import { createBlock as a, openBlock as o, resolveDynamicComponent as n, mergeProps as t, withCtx as l, renderSlot as i } from "vue";
import s from "./index231.js";
function d(e, p, u, g, f, m) {
  return o(), a(n(e.isPRG ? "span" : "a"), t({
    class: "inline underline cursor-pointer hover:underline hover:decoration-color-neutral-grey-40 visited:decoration-color-neutral-grey-40 visited:text-color-neutral-grey-40",
    href: e.isPRG ? null : e.href,
    target: e.isPRG ? null : e.target,
    rel: !e.isPRG && e.rel ? e.rel : null,
    "data-component": e.$options.name,
    "data-mod": e.isPRG ? "prg" : null,
    "data-prg-href": e.isPRG ? e.href : null,
    "data-sign": e.isPRG ? e.sign : null,
    "data-target": e.isPRG ? e.target : null
  }, e.trackingId), {
    default: l(() => [
      i(e.$slots, "default")
    ]),
    _: 3
  }, 16, ["href", "target", "rel", "data-component", "data-mod", "data-prg-href", "data-sign", "data-target"]);
}
const R = /* @__PURE__ */ s(r, [["render", d]]);
export {
  R as default
};
